/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CandidateCredentialParams { 
    /**
     * Credential name, for example: \'Employee\' or \'Fan\' or ...
     */
    credentialName: string;
    /**
     * Credential keys filter, for example: \'iban - ES2100000000000000000000\' and \'swift - BANKESMM000\' for CredentialName = BankAccount 
     */
    credentialKeysFilter?: { [key: string]: string; };
}

